import React from "react";
import { Check } from "lucide-react";

/**
 * Stepper orizzontale del wizard custom, fedele al design Figma
 * (nodi 4002:8054 / 4010:5934 / 4018:2318):
 * - cerchi 40px; attivo #2B7FFF, completato #00644B (verde brand,
 *   check bianco), futuro #CBD5E1 con testo muted
 * - linea 2px staccata dai cerchi (gap 20px), verde al 35% dopo uno
 *   step completato, #E2E8F0 altrimenti
 * - larghezza totale 640px, label 12px sotto il cerchio
 * `current` è 1-based.
 */
const WizardStepper = ({ steps, current }) => (
  <div className="mx-auto flex w-full max-w-[640px] gap-5 px-4">
    {steps.map((step, i) => {
      const n = i + 1;
      const done = n < current;
      const active = n === current;
      const isLast = i === steps.length - 1;

      const circle = done
        ? "bg-[#00644B] text-[#F8FAFC]"
        : active
          ? "bg-[#2B7FFF] text-[#F8FAFC]"
          : "bg-[#CBD5E1] text-[#64748B]";
      const label = done
        ? "text-[#00644B]"
        : active
          ? "text-[#2B7FFF]"
          : "text-[#64748B]";

      return (
        <div
          key={step.key}
          className={`flex flex-col gap-2 ${isLast ? "" : "flex-1"}`}
        >
          <div className="flex h-10 items-center gap-5">
            <div
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${circle}`}
            >
              {done ? <Check className="h-4 w-4" /> : n}
            </div>
            {!isLast && (
              <div
                className={`h-0.5 min-w-[1px] flex-1 ${
                  done ? "bg-[#00644B]/35" : "bg-[#E2E8F0]"
                }`}
              />
            )}
          </div>
          <span className={`whitespace-nowrap text-xs font-medium ${label}`}>
            {step.label}
          </span>
        </div>
      );
    })}
  </div>
);

export default WizardStepper;
